module.exports = __webpack_public_path__ + "img/3Dian5_1.675ddc6a.png";